export default __webpack_public_path__ + "static/media/foto_02.d940c067.jpg";